<div class="manager-container">
  <mat-sidenav-container>

      <mat-sidenav
        #sidenav
        mode="side"
        class="admin-sidebar"
        [fixedTopGap]="70"
        [ngStyle]="{ 'width.em': sidenavWidth }"
        [fixedInViewport]="true"
        opened="true"
      >

        <mat-icon (click)="toggleMenu()" [class.rotate-180]="!isSidenavOpen" class="pointer">menu_open</mat-icon>
<!--        <a class="nav-item" routerLink="dashboard" routerLinkActive="active-link">-->
<!--          <mat-icon>dashboard</mat-icon>-->
<!--          @if (isSidenavOpen) {-->
<!--            <span>Dashboard</span>-->
<!--          }-->
<!--        </a>-->
        <a class="nav-item" routerLink="tracks" routerLinkActive="active-link">
          <mat-icon>library_music</mat-icon>
          @if (isSidenavOpen) {
            <span>Library</span>
          }
        </a>
        <a class="nav-item" routerLink="users" routerLinkActive="active-link">
          <mat-icon>group</mat-icon>
          @if (isSidenavOpen) {
            <span>Users</span>
          }
        </a>

        <hr>

        <a class="nav-item" routerLink="genres" routerLinkActive="active-link">
          <mat-icon>music_note</mat-icon>
          @if (isSidenavOpen) {
            <span>Genres</span>
          }
        </a>
        <a class="nav-item" routerLink="subgenres" routerLinkActive="active-link">
          <mat-icon>music_video </mat-icon>
          @if (isSidenavOpen) {
            <span>Subgenres</span>
          }
        </a>
        <a class="nav-item" routerLink="categories" routerLinkActive="active-link">
          <mat-icon>topic</mat-icon>
          @if (isSidenavOpen) {
            <span>Categories</span>
          }
        </a>
        <a class="nav-item" routerLink="playlists" routerLinkActive="active-link">
          <mat-icon>queue_music</mat-icon>
          @if (isSidenavOpen) {
            <span>Playlists</span>
          }
        </a>
        <a class="nav-item" routerLink="carousel-images" routerLinkActive="active-link">
          <mat-icon>view_carousel</mat-icon>
          @if (isSidenavOpen) {
            <span>Carousel Images</span>
          }
        </a>

      </mat-sidenav>

    <mat-sidenav-content class="content-container" [ngStyle]="{ 'margin-left.em': sidenavWidth }">

      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

